import request from '@/utils/request'


// 查询订单售后列表
export function listOrderRefund(query) {
  return request({
    url: '/order/refund/list',
    method: 'get',
    params: query
  })
}

// 查询订单售后分页
export function pageOrderRefund(query) {
  return request({
    url: '/order/refund/page',
    method: 'get',
    params: query
  })
}

// 查询订单售后详细
export function getOrderRefund(data) {
  return request({
    url: '/order/refund/detail',
    method: 'get',
    params: data
  })
}

// 新增订单售后
export function addOrderRefund(data) {
  return request({
    url: '/order/refund/add',
    method: 'post',
    data: data
  })
}

// 修改订单售后
export function updateOrderRefund(data) {
  return request({
    url: '/order/refund/edit',
    method: 'post',
    data: data
  })
}

// 修改订单售后
export function updateOrderDirect(data) {
  return request({
    url: '/order/refund/direct',
    method: 'post',
    data: data
  })
}


export function searchLogistics(logisticsNumber) {
  return request({
    url: '/order/refund/searchLogistics?logisticsNumber='+logisticsNumber,
    method: 'get',
  })
}

// 删除订单售后
export function delOrderRefund(data) {
  return request({
    url: '/order/refund/delete',
    method: 'post',
    data: data
  })
}
